import { useState } from "react";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import PropTypes from "prop-types";

import {
    Grid,
    TextField
  } from '@mui/material';
const AddGolfCoursePage = (props) => {
    const { latitudLongitud,direccion,direccionPersona} = props;

  // Your existing state variables and functions here
  const [address, setAddress] = useState(direccionPersona ? direccionPersona:"");

  // Handle place selection
  const handleSelect = async (address) => {
    setAddress(address);
    const results = await geocodeByAddress(address);
    const latLng = await getLatLng(results[0]);
    latitudLongitud(latLng);
    direccion(address)
  };

  // Modify your return statement
  return (
    <div style={{ padding: 8 }}>
      {/* Search Input */}
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
        searchOptions={{
          types: [],
          componentRestrictions: { country: "ec" },
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <Grid >
                <TextField
              {...getInputProps({
                placeholder: "Buscar destino...",
                className: "location-search-input",
                style: {
  
                  zIndex: 100,
                  width:'100%',
                },
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const style = suggestion.active
                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
                  : { backgroundColor: "#ffffff", cursor: "pointer" };
                return (
                  <div {...getSuggestionItemProps(suggestion, { style })}>
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </Grid>
        )}
      </PlacesAutocomplete>
      {/* The rest of your component here */}
    </div>
  );
};
AddGolfCoursePage.propTypes = {
    latitudLongitud: PropTypes.func,
    direccion: PropTypes.func
  };
  AddGolfCoursePage.defaultProps = {
    latitudLongitud: (value) => { },
        direccion: (value) => { },

  };
export default AddGolfCoursePage;